module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_4_2.c9e485f3.jpeg";